import { LOCALE } from './format';

const pad = (n) => String(n).padStart(2, '0');

// Local calendar date as YYYY-MM-DD (not UTC, so late-evening meals land on the right day).
export const toISODate = (date) => `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;

export const parseISODate = (iso) => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Date(y, m - 1, d);
};

export const today = () => toISODate(new Date());

export const addDays = (iso, days) => {
  const date = parseISODate(iso);
  date.setDate(date.getDate() + days);
  return toISODate(date);
};

export const nextMonday = () => {
  const date = new Date();
  date.setDate(date.getDate() + ((8 - date.getDay()) % 7 || 7));
  return toISODate(date);
};

export const formatDay = (iso, opts = { weekday: 'short', day: 'numeric', month: 'short' }) =>
  parseISODate(iso).toLocaleDateString(LOCALE, opts);

// "26/10": how dates are usually written in Vietnamese (the browser's vi-VN short format gives "26-10").
export const shortDate = (iso) => {
  const date = parseISODate(iso);
  return `${date.getDate()}/${date.getMonth() + 1}`;
};

export const relativeDayLabel = (iso) => {
  const t = today();
  if (iso === t) return 'Hôm nay';
  if (iso === addDays(t, -1)) return 'Hôm qua';
  if (iso === addDays(t, 1)) return 'Ngày mai';
  return formatDay(iso);
};

// "Thứ Bảy, 24/10"
export const longDate = (iso) => {
  const weekday = parseISODate(iso).toLocaleDateString(LOCALE, { weekday: 'long' });
  return `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)}, ${shortDate(iso)}`;
};

// Weeks start on Monday (T2) and end on Sunday (CN).
export const WEEKDAY_SHORT = ['T2', 'T3', 'T4', 'T5', 'T6', 'T7', 'CN'];
export const weekStart = (iso) => addDays(iso, -((parseISODate(iso).getDay() + 6) % 7));
export const weekDays = (iso) => Array.from({ length: 7 }, (_, i) => addDays(weekStart(iso), i));

// Midnight to 5:00 is late night, not morning.
export const isLateNight = (date = new Date()) => date.getHours() < 5;

export const greeting = (date = new Date()) => {
  const hour = date.getHours();
  if (isLateNight(date)) return 'Khuya rồi';
  if (hour < 11) return 'Chào buổi sáng';
  if (hour < 13) return 'Chào buổi trưa';
  if (hour < 18) return 'Chào buổi chiều';
  return 'Chào buổi tối';
};

// Age in whole years on `onDate` (default today), counting the birthday only once it has passed.
export const ageOn = (dateOfBirth, onDate = today()) => {
  const [by, bm, bd] = dateOfBirth.split('-').map(Number);
  const [y, m, d] = onDate.split('-').map(Number);
  return y - by - (m < bm || (m === bm && d < bd) ? 1 : 0);
};
